import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getDatabase, ref, onValue, update } from 'firebase/database';
import { app } from '../firebase';
import { TextField, Button, Grid, Paper, Typography } from '@mui/material';

const NewEditUser = () => {
    const { id } = useParams();
    const [userDetails, setUserDetails] = useState(null);

    useEffect(() => {
        const db = getDatabase(app);
        const userRef = ref(db, `users/${id}`);

        const unsubscribe = onValue(userRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                setUserDetails(data);
            }
        });
        return () => unsubscribe();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserDetails((prev) => ({ ...prev, formData: { ...prev.formData, [name]: value } }));
    };

    const handleDoorChange = (index, e) => {
        const { name, value } = e.target;
        const updatedDoorData = userDetails.doorData.map((door, i) =>
            i === index ? { ...door, [name]: value } : door
        );
        setUserDetails((prev) => ({ ...prev, doorData: updatedDoorData }));
    };

    const addDoor = () => {
        setUserDetails((prev) => ({
            ...prev,
            doorData: [...prev.doorData, { label: '', selectedOption: '', additionalFields: {} }],
        }));
    };

    const removeDoor = (index) => {
        const updatedDoorData = userDetails.doorData.filter((_, i) => i !== index);
        setUserDetails((prev) => ({ ...prev, doorData: updatedDoorData }));
    };

    const handleUpdate = () => {
        const db = getDatabase(app);
        const userRef = ref(db, `users/${id}`);
        update(userRef, userDetails)
            .then(() => {
                alert('User updated successfully');
            })
            .catch((error) => {
                console.error('Error updating user:', error);
            });
    };

    if (!userDetails) return <div>Loading...</div>;

    return (
        <Paper style={{ padding: '20px', margin: '20px', borderRadius: '10px' }}>
            <Typography variant="h4" gutterBottom>Edit User</Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <TextField
                        label="First Name"
                        name="firstName"
                        value={userDetails.formData?.firstName || ''}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        label="Last Name"
                        name="lastName"
                        value={userDetails.formData?.lastName || ''}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label="Address"
                        name="address"
                        value={userDetails.formData?.address || ''}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label="City"
                        name="city"
                        value={userDetails.formData?.city || ''}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        label="State"
                        name="state"
                        value={userDetails.formData?.state || ''}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        label="ZIP Code"
                        name="zipCode"
                        value={userDetails.formData?.zipCode || ''}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        label="Phone"
                        name="phone"
                        value={userDetails.formData?.phone || ''}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        label="Cell"
                        name="cell"
                        value={userDetails.formData?.cell || ''}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        label="Work"
                        name="work"
                        value={userDetails.formData?.work || ''}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        label="Year Built"
                        name="yearBuilt"
                        value={userDetails.formData?.yearBuilt || ''}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                    />
                </Grid>
            </Grid>

            <Typography variant="h5" gutterBottom style={{ marginTop: '20px' }}>Door Data</Typography>
            {userDetails.doorData.map((door, index) => (
                <Grid container spacing={2} key={index} style={{ marginBottom: '15px' }}>
                    <Grid item xs={12} md={3}>
                        <TextField
                            label="Category"
                            name="label"
                            value={door.label}
                            onChange={(e) => handleDoorChange(index, e)}
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            label="Detail Type"
                            name="selectedOption"
                            value={door.selectedOption}
                            onChange={(e) => handleDoorChange(index, e)}
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <TextField
                            label="Width (Inches)"
                            name="width"
                            value={door.additionalFields?.width || ''}
                            onChange={(e) => handleDoorChange(index, e)}
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <TextField
                            label="Height (Inches)"
                            name="height"
                            value={door.additionalFields?.height || ''}
                            onChange={(e) => handleDoorChange(index, e)}
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <TextField
                            label="Sqft/Lft"
                            name="sqftLft"
                            value={door.additionalFields?.sqftLft || ''}
                            onChange={(e) => handleDoorChange(index, e)}
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <TextField
                            label="Unit Cost"
                            name="unitCost"
                            value={door.additionalFields?.unitCost || ''}
                            onChange={(e) => handleDoorChange(index, e)}
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <TextField
                            label="Estimated Cost"
                            name="estimatedCost"
                            value={door.additionalFields?.estimatedCost || ''}
                            onChange={(e) => handleDoorChange(index, e)}
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <TextField
                            label="Price"
                            name="price"
                            value={door.additionalFields?.price || ''}
                            onChange={(e) => handleDoorChange(index, e)}
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => removeDoor(index)}
                            style={{ marginTop: '30px' }}
                        >
                            Remove Door
                        </Button>
                    </Grid>
                </Grid>
            ))}
            <Button variant="contained" color="primary" onClick={addDoor} style={{ marginTop: '20px' }}>
                Add Door
            </Button>

            <Button onClick={handleUpdate} variant="contained" color="primary" style={{ marginTop: '20px', marginLeft: '10px' }}>
                Update User
            </Button>
        </Paper>
    );
};

export default NewEditUser;
